import React, { useEffect } from "react";
import { Modal, Input, Form, InputNumber } from "antd";
import { observer } from "mobx-react";
import { rolesStore } from "../../../store/admin/role/RolesStore";
import { AuthPermissionsInput } from "./AuthPermissionsInput";

export const RoleDlg = observer(() => {
  const [form] = Form.useForm();

  const rules: any = {
    name: [{ required: true, trigger: "change" }],
  };

  useEffect(() => {
    form.setFieldsValue(rolesStore.edit.model);
  }, [rolesStore.edit.model]);

  const save = () => {
    form.validateFields().then((values) => {
      rolesStore.edit.save({ ...values, permissions: rolesStore.edit.model.permissions || [] });
    });
  };

  const layout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 18 },
  };

  return (
    <Modal
      title="Role"
      visible={rolesStore.edit.visible}
      onOk={save}
      width={800}
      centered
      maskClosable={false}
      confirmLoading={rolesStore.edit.saving}
      onCancel={() => rolesStore.edit.close()}
    >
      <Form form={form} {...layout} initialValues={{ ...rolesStore.edit.model }}>
        <Form.Item label="Name" name="name" rules={rules.name}>
          <Input placeholder="Enter name" disabled />
        </Form.Item>
        <Form.Item label="Order" name="sortOrder">
          <InputNumber />
        </Form.Item>
        <Form.Item label="Permissions">
          <AuthPermissionsInput
            value={rolesStore.edit.model.permissions}
            tree={rolesStore.resTree}
            onChange={(v) => {
              rolesStore.edit.model.permissions = v;
            }}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
});
